<template>
  <section class="text_center">
    <h2 class="header_underline">LINE登録エラー</h2>
    <p>LINE登録時にエラーが発生しました。<br>ご迷惑をおかけしますが時間をおいて再度お試しください。</p>
    <p><router-link :to="{ name: 'Top' }" class="decoration_link_arrow_blue">トップページへ戻る</router-link></p>
  </section>
</template>

<script>
export default {
  name: 'LineTopError'
}
</script>
